var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2.8v17.8l53.3 8.3v-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M0 12.2v8.4l53.3 16.6V29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M25.3 31.7a7 7 0 0 1-3-1.2v.3q0 .4-.5.6-.7 0-1.3-.5t-1.4-.7-1.6.2h-.1V30q.1-.4.5-.4l.2-.2v-.2q-.2-.4.1-.7.5-.4 1.2-.1h.3l-.2-.3-.2-.7a1 1 0 0 1 .8-.7q.3-.1 1 .5a8 8 0 0 0 4.8 2.3h1.9q2.6-.5 4.5-2.3l.8-.4q.4 0 .7.3l.2.6q0 .3-.2.4-.2.4.2.2.8-.3 1.2.2.4.3 0 .7v.3h.3q.5.2.5.8v.2l-.3-.1-1-.2h-.8l-1 .7q-.4.4-1 .4t-.6-.3l-.1-.3v-.3l-.3.2-1 .5q-2.2.8-4.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M26 29.2a8 8 0 0 1-5.5-3.1 9 9 0 0 1-1.4-6.5q.3-1.6 1.4-2.8a7 7 0 0 0 5.1 9.6c1.2.4 2.3 0 3.4-.3 2.3-.8 4-3 4.3-5.5q.3-2-.6-4c.3.2.7 1 1 1.4q1.3 2.7.4 5.6a8 8 0 0 1-8.2 5.6m-10.8-3.1q-.2 0-.2.3l.4.3 1.3.2 1-.2.4-.3q0-.2-.2-.2l-.5.1q-.5.2-1.1.1l-.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M15.3 25.5q-.3 0-.2.3t.4.3l1 .2q.5 0 .9-.2l.4-.3-.1-.2h-.3l-1.2.3q-.4 0-.7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M15.5 25q-.2 0-.2.2t.2.2q.4.3 1 .3l.7-.1q.3 0 .4-.3V25h-.3q-.4.2-.9.2l-.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M13.4 16.8q-.2.3 0 .8 0 1 .5 2.1l1.4 1.7q.2.4.2.9v2.6q.5.3 1.2.3t.8-.4v-4.4q-.4-.6-1-1l-.8-.9c-.1-.2-.7-.3-.5.1l.5 1c0 .3.3.7 0 .8q-.1-.4-.5-.6-.6-.1-.8-.6 0-.6-.6-1.2.2-.7-.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M14 16.9q-.3 0-.1.3v.8q.5.4.6 1.2 0 .2.3.3l.8.5h.1l-.2-.4-.5-.3q0-.4-.3-.7 0-.3-.4-.5l-.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M14.4 17v1l.5.7.2.5.4.2-.2-.4-.2-.5-.3-.6q0-.5-.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m15 17.1-.2.1v.2q.3.3.2.6v.4a.2.2 0 0 1 .3-.2l-.1-.8zm23.2 9q.3 0 .3.3l-.5.3-1.3.2-1-.2-.3-.3q-.2-.3.1-.2l.5.1q.6.2 1.2.1l.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M38 25.5q.3 0 .3.3l-.5.3-1 .2-.8-.2q-.4 0-.4-.3v-.2h.4q.5.3 1.1.3.4 0 .7-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m37.9 25 .2.2-.2.2q-.5.3-1 .3h-.1l-.7-.1-.4-.3V25h.3q.4.2 1 .2l.6-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M40 16.8v.8q-.1 1-.5 2.1L38 21.4l-.1.9v2.6q-.6.3-1.3.3-.5 0-.8-.4v-4.4q.4-.6 1-1l.8-.9c.2-.2.7-.3.5.1l-.5 1c0 .3-.3.7 0 .8q.1-.4.6-.6t.7-.6q0-.6.6-1.2-.1-.7.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M39.4 16.9V18q-.5.4-.6 1.2 0 .2-.3.3l-.8.5.1-.4q.2-.3.6-.3 0-.4.2-.7l.4-.5.2-1q0-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M39 17v1l-.6.7-.1.5-.5.2.3-.4.2-.5.2-.6q0-.5.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m38.4 17.1.1.1v.2l-.1.6-.1.4-.2-.2v-.8zm-12 9.3a2 2 0 0 1-1.6-1.3h.2q.2.3.5.2l.5.4s.4.2.3 0v-.4q0-.3.4-.6l.3.3.1.6.1.3.6-.5q.3 0 .5-.2t.3 0q0 .3-.4.6-.4.5-1 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M27.3 25.6V25l-.5-.6q-.3 0-.4.3t-.3.7q-.2.2-.4-.2l-.2-.6.2-1.2.3-1q0-.4-.3-.6c-.2-.2.2-.2.3-.1q.1.2.4.2l.2-.5q.2 0 .3.2t.2.4l.5-.4.1.1-.3.6.1.9q.5.7.3 1.7 0 .3-.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m27 21.6-.3-.3-.3.2q0 .3-.3.2-.3-.4-.3-.7 0-.7.3-1.2t0-.8q0-.4-.4-.7h.3q.3 0 .4.3l.1-.3q0-.4.3-.1l.1.4q.2 0 .4-.3h.4l-.2.3a1 1 0 0 0-.2 1l.2.8v1q0 .3-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M26.2 18.2q-.3-.2-.2-.6v-.3q.3-.2 0-.2-.4.1-.5-.2l.2-.4.2-.2-.5.4-.6.6q-1 .5-1.4.1v-.3q.2 0 .3-.2.4-.4 1-.6.2-.2 0-.2-.4 0-1 .7l-.5.3h-.7l-.4-.3.1-.1.3-.2 1.4-.7q.2 0 0 0-.8 0-1.5.6c-.4.4-1.1.3-1.3 0v-.2l1-.5 1-.3q.3 0 0-.1l-1 .3q-.8.4-1.2.4a1 1 0 0 1-.8-.4l-.4-.6h1.8l1.3-.7q1-.8 2-.8t1.5.6l.3.2v-.5h.3v.5l.2-.1q.1-.3.5-.5a3 3 0 0 1 3 .5l1.3.7a3 3 0 0 0 1.7 0q.2.1-.3.7-.7.6-2 0-1-.5-1.1-.3.3 0 1.1.4.5.3 1 .3.2 0 0 .3-.1.3-.6.3t-.7-.3c-.5-.4-1.6-.8-1.5-.5h.1q.8.2 1.3.6l.4.3v.1q-.2.3-.5.3a1 1 0 0 1-.9-.3q-.8-.7-1.2-.8l.2.3.9.6.2.2v.3l-.5.2q-.7 0-1.5-1l-.4-.4.1.3q.3.3.2.5t-.4.1q-.4 0-.1.2.3.5-.1.8l-.2.2-.1-.2q-.3-.3-.5 0l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m27 13-.2.2-.3-.2v1.5h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M25.3 11.4q0 1-.5 1.7l.6-.5.4.5.5-.5.5.4.4-.5.5.6.4-.5.7.5q-.5-.7-.6-1.8c-.6.5-2.2.6-3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M26.5 11h-.7l-.5.2c0 .5 2.3.7 3 0l-.5-.2H27v.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "M27 8.6h-.4v2.7h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf1126",
    d: "m27 8.6-.2 1.3 1.4.7-.7-1 1-.2zm-.2-.3q-.3 0-.4.2l.4.1.3-.1q0-.2-.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M26.2 31.3q.3 0 .4-.4v-.3q0-.2-.1 0l-.1.2q.1.4-.6.4H25l.2.2zm1.2 0 .2-.2.3-.1q.3-.4 0-.8-.3-.3-.4 0v.2q.2 0 .2.2.3.3-.1.4l-.3.1v.2M27 31v-1.2l-.2.1v.8q0 .8.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m26 30.8.1-.5V30q0-.2 0 0h-.2v1zm-.8 0q.3-.1.2-.6v-.5q-.2 0-.1.4zq-.3.2-.4 0 0-.4-.4-.1l-.2-.1q-.1-.2-.4-.1c-.2 0 0-.3-.3-.2q-.5 0-1-.3-.4-.1-.1-.4 0-.4.3-.7h-.3l-.1.5q-.1.2-.4.3-.4-.1-.7-.5-.1.1 0 .4l.6.3q.3 0 .5.3l1 .2q.1.2.3.2l.4.1q-.1.3.3.2h.3q.3.3.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m21.9 29.2.2-.3q0-.3.2-.3 0-.2-.2-.2v.1zq-.2.2 0 .2zm-2-1.3q-.3 0-.1.1l.2.2q0 .4.6.4h.3v.3h.2l.4-.5-.3-.2-.2.1q-.5.3-.8 0-.2-.4-.4-.4m1.3.5v.2H21zm10.5-.3-.2.1v.6q0 .2.2 0h.2q0 .6-.7 1l-.2.2h.3q.4-.3.6-.7l.1-.6v-.5zm0 .2.1.1v.2h-.2zM30 30.7q.6-.3.7-.6v-.3l-.2-.1v-.2l-.1-.4h-.1v.3l-.2.4-.1.1v.1h.2l.1-.2.1.1.1.2q-.1.4-1 .5h-.2v-.4q0-.3-.2 0t0 .5l.5.1zm2.2-1.2q.3-.3.3-.9v-.2l.2-.1q.4-.2.4-.5H33l-.5.4-.2.4q0 .5-.3.8t0 .2zm-2.2-.3h-.2q.1.2.2 0m3-.7v-.1h-.1q0 .2.1 0m-3.6-2.2-.2.2.3.6v.7l-.2.2-.5-.1-.4.1-.2-.1v.3h.4v.4h.4l.2-.4h.2l.4-.6-.3-.9zm-.5 1.8v.2q0 .1-.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m24.7 27-.2.1q-.5.4-.2.6.2 0 0 .2-.5.3-1.3 0h-.1q0 .2.4.3h1l.3-.3.1-.2h.3q.3 0 .2.2h.3l.4.1h.2l.4.1h1q.5 0 .7-.4h.2q.4 0 0-.2h-.3l-.3-.1-.3.1h.2l.3.1v.1q-.1.2-.5.3h-.2q-.2-.2-.4 0v-.1h-1l-.4-.1v-.2q0-.2-.2 0-.5 0-.4-.3zm-.1.3v.1q0 .2-.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M24 27.5q.2.1.2-.4v-.3q-.2 0-.2.3zq-.4.1-.7-.1l.1-.3q.3-.4 0-.1-.2.2-.2 0l-.2-.1v.1l-.2.2-.2-.2.5-.7.2-.3h-.2l-.4.6q-.6.5-.3.6h.7q0 .4.2.5zm8.7-2.9q-.2.2 0 .5l-.5.2q-.4.1-.4.5s-.2.3-.3 0H31l-.1.4-.2-.3q-.3.1 0 .4v.4q-.1.3-.5.1l-.1-.3-.2.2-.1-.4q-.2 0-.2.3l.3.7v.3-.5h.6q.3 0 .4-.4v-.4h.5v.5q-.2.4-.5.6-.1.3 0 .2.5-.3.6-.7v-.7l.5-.1q.3 0 .3-.4l.3-.3q.3 0 .2-.4zm-.6 1c.2.1 0 .5-.1.3zm-.9.3c.3 0 .2.4 0 .2zM25.3 27q-.1 0 0 0m-3.5-1.7-.2.2-.3.3h-.4v-.3l-.3.1.2.3q.2 0 .3.2l.1.1q.2 0 .1.3v.3l.1-.1.1-.1h.7l.4-.2.4-.5v-.2q-.2 0-.3.3l-.4.4h-.4l.1-.1.2-.2-.2-.1-.6.2V26l.4-.5.1-.2m.1.8-.1.2zm-.3.3q.1 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M24.1 26.5H24zm6.2-.6h-.1v.1zm-9.6-.7v-.6q.4 0 .6.3v.2q-.3.1 0 .2l.2-.3-.4-.5h-.4q-.3 0-.2.3 0 .5-.3.1l-.3-.7q0-.4.4-.6.3 0 0 0-.4-.2-.6.4-.1.8.5 1.1.3.3.5 0m11.6-.5.1-.3v-.1h-.3l.1-.1q.3 0 0-.2l-.2.3v.2q.2 0 .1.1 0 .3.2.1m1 0 .2-.3.2-.1q.3-.3.1-.6 0-.2-.4-.5l-.5-.4v.3q.3 0 .5.3.4.5.3.6l-.4-.2-.2-.2v.1l.1.3q.3.3 0 .5l-.8-.8v.3l.6.6.2.2zm.6-1.5-.8-.8v.4q.3 0 .4.3zm-4 7.7a.1.1 0 0 1-.2 0v-.1a.1.1 0 0 1 .2 0m.3 0a.1.1 0 0 1-.2 0v-.1a.1.1 0 0 1 .2 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBn);
export default __webpack_public_path__ + "static/media/bn.6664f9b422061f1bfcd878ae16503b64.svg";
export { ForwardRef as ReactComponent };